import packageJson from "../package.json";

const AppConfig = {
  env: process.env.REACT_APP_ENV,
  version: packageJson.version,
  domain: process.env.REACT_APP_DOMAIN ?? "retirementbudgetcalculator.com",
  baseUrl: process.env.REACT_APP_BASE_URL,
  homeUrl: process.env.REACT_APP_HOME_URL,
  investUrl: process.env.REACT_APP_INVEST_URL,
  branch: process.env.REACT_APP_BRANCH,
  google: {
    trackingId: process.env.REACT_APP_GOOGLE_TRACKING_ID,
    options: {
    }
  },
  stripe: {
    key: process.env.REACT_APP_STRIPE_KEY
  },
  convertKit: {
    enabled: process.env.REACT_APP_CONVERTKIT_ENABLED === "true"
  },
  webFlow: {
    enabled: process.env.REACT_APP_WEBFLOW_ENABLED === "true"
  },
  facebook: {
    pixelId: process.env.REACT_APP_PIXEL_ID
  },
  disableSignup: process.env.REACT_APP_DISABLE_SIGNUP === "true",
};

export default AppConfig;